export default "__VITE_ASSET__BEQEsj$b__"